<div class="content-wrapper">
  <div class="products-list-container">
    <div class="products-header-info" *ngIf="!isConfigurationVisible">
      <h3>{{ 'view_translations.products_header_info' | translate }}</h3>
    </div>
    <div class="products-list-header" *ngIf="!isConfigurationVisible">
      <div class="search-bar" [ngClass]="{'focused': searchBarFocused === true }">
        <nb-icon class="search-icon" icon="search" pack="icomoon"></nb-icon>
        <input
          #searchInput
          type="search"
          placeholder="{{ 'view_translations.search' | translate }}"
          (focus)="searchBarFocused = true"
          (blur)="searchBarFocused = false"
          tabindex="-1"
          (input)="searchName(searchInput.value)" />
      </div>
      <app-sort-dropdown #dropdown (emitChosenValue)="getSortValue($event)" [sortValues]="dropdownValues" [sortDropdownClass]="sortClass" class="flex-1">
      </app-sort-dropdown>
    </div>
    <div class="loader-wrapper" *ngIf="!isLoaded">
      <app-loader [minHeight]="290"></app-loader>
    </div>
    <div class="products-list" *ngIf="!isConfigurationVisible && isLoaded" (scroll)="checkIfScrolled()" id="allProducts">
      <div class="single-product-container" *ngFor="let product of productsList">
        <app-single-product
          [productData]="product"
          (isProductSelected)="showProductConfig($event)"
          (selectedProductData)="selectedProduct = $event"></app-single-product>
        <div class="tooltip-container" [ngbTooltip]="descriptionTooltip" placement="left" tooltipClass="my-configurations-tooltip wider-toolip">
          <nb-icon icon="info" pack="icomoon"></nb-icon>
        </div>
        <ng-template #descriptionTooltip>
          <div [innerHTML]="product.description "></div>
        </ng-template>
      </div>
      <div class="modal-inner-container-mask" *ngIf="!scrolledToBottom || fetchingNextPage">
        <app-loader-for-list *ngIf="fetchingNextPage"></app-loader-for-list>
      </div>
    </div>
  </div>
  <div class="program-configurtion-container" *ngIf="isConfigurationVisible">
    <app-configuration-created
      [currentCampaign]="currentCampaign"
      [selectedConfigData]="selectedProduct"
      (emitConfiguration)="addProduct($event)"
      (backToBannersList)="changeVisibility($event)"
      [isSuccessfullySubmitted]="isSuccessfullySubmitted"
      [configurationData]="productConfigurationData"
      [component]="'products'">
    </app-configuration-created>
  </div>
</div>
